var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveMedallion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2_892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 1.31826C13.1133 0.0539497 15.1367 0.0539501 16.3504 1.31826V1.31826C17.1053 2.10476 18.2201 2.4341 19.2812 2.18364V2.18364C20.9783 1.78304 22.6749 2.89734 23.016 4.60736V4.60736C23.2298 5.67919 23.9926 6.57603 25.0212 6.94557V6.94557C26.6682 7.53729 27.4968 9.3901 26.8658 11.0224V11.0224C26.4705 12.0449 26.6339 13.2146 27.2999 14.0853V14.0853C28.3675 15.481 28.0848 17.488 26.6672 18.5263V18.5263C25.7839 19.1732 25.3035 20.2507 25.3974 21.3414V21.3414C25.547 23.08 24.2333 24.6288 22.4911 24.7276V24.7276C21.4016 24.7894 20.4206 25.4288 19.9165 26.3966V26.3966C19.1096 27.9455 17.1685 28.5285 15.6524 27.6614V27.6614C14.7061 27.1201 13.5439 27.1201 12.5976 27.6614V27.6614C11.0815 28.5285 9.14042 27.9455 8.33351 26.3966V26.3966C7.82935 25.4288 6.84842 24.7894 5.75894 24.7276V24.7276C4.0167 24.6288 2.70301 23.08 2.85265 21.3414V21.3414C2.94653 20.2507 2.46609 19.1732 1.58284 18.5263V18.5263C0.165174 17.488 -0.117525 15.481 0.950096 14.0853V14.0853C1.6161 13.2146 1.77947 12.0449 1.38421 11.0224V11.0224C0.753191 9.3901 1.58181 7.53729 3.22881 6.94557V6.94557C4.25739 6.57603 5.02022 5.67919 5.23402 4.60736V4.60736C5.57514 2.89734 7.27174 1.78304 8.96881 2.18364V2.18364C10.0299 2.4341 11.1447 2.10476 11.8996 1.31826V1.31826Z",
    fill: "#D9DBDD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7415 11.2472C17.6377 11.1431 17.4967 11.0847 17.3497 11.0847C17.2027 11.0847 17.0618 11.1431 16.9579 11.2472L14.2403 13.9593L11.5227 11.2417C11.4189 11.1376 11.2779 11.0791 11.1309 11.0791C10.9839 11.0791 10.8429 11.1376 10.7391 11.2417C10.5224 11.4584 10.5224 11.8085 10.7391 12.0253L13.4567 14.7429L10.7391 17.4605C10.5224 17.6772 10.5224 18.0273 10.7391 18.2441C10.9558 18.4608 11.306 18.4608 11.5227 18.2441L14.2403 15.5265L16.9579 18.2441C17.1747 18.4608 17.5248 18.4608 17.7415 18.2441C17.9583 18.0273 17.9583 17.6772 17.7415 17.4605L15.0239 14.7429L17.7415 12.0253C17.9527 11.8141 17.9527 11.4584 17.7415 11.2472Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.795 11.1937C17.677 11.0755 17.5168 11.009 17.3497 11.009L17.7415 12.0253C17.9527 11.8141 17.9527 11.4584 17.7415 11.2472L17.7951 11.1938C17.795 11.1938 17.795 11.1938 17.795 11.1937ZM17.795 17.407L15.1309 14.7429L16.9045 11.1937L16.9045 11.1937C16.9044 11.1938 16.9044 11.1938 16.9044 11.1938L14.2404 13.8524L11.5762 11.1882C11.5762 11.1882 11.5762 11.1882 11.5762 11.1882C11.4582 11.0699 11.298 11.0035 11.1309 11.0035C10.9638 11.0035 10.8036 11.07 10.6856 11.1882L10.7391 11.2417L10.6856 11.1882C10.4393 11.4345 10.4393 11.8325 10.6856 12.0787L13.3498 14.7429L10.6856 17.407C10.4393 17.6533 10.4393 18.0513 10.6856 18.2976C10.9319 18.5438 11.3299 18.5438 11.5762 18.2976L14.2403 15.6334L16.9044 18.2976C17.1507 18.5438 17.5487 18.5438 17.795 18.2976C18.0413 18.0513 18.0413 17.6533 17.795 17.407Z",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 0.15125
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2_892",
    x: -2.72202,
    y: -1.64655,
    width: 32.6857,
    height: 31.7277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.01667,
    dy: 2.01667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.26875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.887695 0 0 0 0 0.887695 0 0 0 0 0.887695 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2_892"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.025,
    dy: -2.01667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.52083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.829362 0 0 0 0 0.829362 0 0 0 0 0.829362 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2_892",
    result: "effect2_innerShadow_2_892"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveMedallion);
export default __webpack_public_path__ + "static/media/inactive-medallion.3980e3c2a87602e42a0364114baa8feb.svg";
export { ForwardRef as ReactComponent };